var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import getAccountList from '../../../ts/getAccountList';
// コンポーネントの設定
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getAccountList = new getAccountList();
        return _this;
    }
    MyPage = __decorate([
        Component({
            name: 'account_list',
            methods: {},
            data: function () { return ({
                title: "所属グループのアカウント一覧",
            }); }
        })
    ], MyPage);
    return MyPage;
}(Vue));
export default MyPage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/AccountList.vue
// module id = 268
// module chunks = 1